<template>
  <div class="mfs-container">
    <h6 style="padding: 0;">{{$t('map.trans_type')}}
      <span @click='toggleNS'>{{$t('map.site_inquire_display_none')}}
        <img v-if="$store.getters.filter.not_show_site_inquire == 'Y'" src="../../../assets/image/ic_check_on@2x.png" class="img_check">
        <img v-if="$store.getters.filter.not_show_site_inquire != 'Y'" src="../../../assets/image/ic_check_off@2x.png" class="img_check">
      </span>
      <small v-if="false" class="notice">{{$t('map.filter_notice')}}</small>
    </h6>
    <div class="mt-2 mb-2">
      <b-button variant="white" v-for="(v,k,i) in $c.TRANS_TYPE_MAP1" :key="i"
                size="sm"
                :pressed="checkTransType(v)"
                @click="() => {
                  $store.commit('setFilter', {trans_type: v, fee_type:$c.TRANS_TYPE_MAP1[k]})
                }">{{k}}</b-button>
    </div>
    <!-- Trading -->
    <div v-if="checkTransType($c.TRANS_TYPE_MAP1[$t('interest.trading')])">
      <h6 class="" style="padding: 0;margin-top: 20px;">{{$t('interest.trading')}}
        <small class="price">
          {{sc_range[0]}} ~ {{sc_range[1]}}
        </small>
      </h6>
      <div class="mt-2 mb-5 mr-3 ml-3">
        <vue-slider v-model="s_range" :enable-cross="false" :interval="50" :min="0"
                  :max="1000" :tooltip="'none'" :marks="marks">
          <template v-slot:mark="{ pos, label }">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
      <!--수수료-->
      <template v-if="false">
        <h6 class="mt-2">{{$t('register.trading_fee')}}
          <small class="price">
            {{trading[0]}} ~ {{(trading[1] == 100) ? $t('map.unlimited') : trading[1]}}
          </small>
        </h6>
        <div class="mt-2 mb-5 mr-3 ml-3">
          <vue-slider v-model="trading" :enable-cross="false" :min="0" :interval="5"
                      :max="100" :tooltip="'none'" :marks="marks_fee">
            <template v-slot:mark="{pos, label}">
              <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
                |<br>{{ label }}
              </div>
            </template>
          </vue-slider>
        </div>
      </template>
    </div>
    <!-- Charter -->
    <div v-if="checkTransType($c.TRANS_TYPE_MAP1[$t('interest.charter')])">
      <h6 class="mt-3" style="padding: 0;">{{$t('interest.charter')}}
        <template v-if="false">
          <span @click='toggleSC'>{{$t('map.safe_charter')}}
            <img v-if="$store.getters.filter.safe_charter == 'Y'" src="../../../assets/image/ic_check_on@2x.png" class="img_check">
            <img v-if="$store.getters.filter.safe_charter != 'Y'" src="../../../assets/image/ic_check_off@2x.png" class="img_check">
          </span>
            <span @click='toggleSB'>{{$t('map.small_business')}}
            <img v-if="$store.getters.filter.smb == 'Y'" src="../../../assets/image/ic_check_on@2x.png" class="img_check">
            <img v-if="$store.getters.filter.smb != 'Y'" src="../../../assets/image/ic_check_off@2x.png" class="img_check">
          </span>
        </template>
        <small class="price">
          {{cc_range[0]}} ~ {{cc_range[1]}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="c_range" :enable-cross="false" :interval="50"
                  :min="0" :max="1000" :tooltip="'none'" :marks="marks">
          <template v-slot:mark="{ pos, label }">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
      <!--수수료-->
      <template v-if="false">
        <h6 class="mt-5">{{$t('register.charter_fee')}}
          <small class="price">
            {{charter[0]}} ~ {{(charter[1] == 100) ? $t('map.unlimited') : charter[1]}}
          </small>
        </h6>
        <div class="mt-3 mb-5 mr-3 ml-3">
          <vue-slider v-model="charter" :enable-cross="false" :min="0" :interval="5"
                      :max="100" :tooltip="'none'" :marks="marks_fee">
            <template v-slot:mark="{pos, label}">
              <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
                |<br>{{ label }}
              </div>
            </template>
          </vue-slider>
        </div>
      </template>
    </div>
    <!-- Monthly -->
    <div v-if="checkTransType($c.TRANS_TYPE_MAP1[$t('interest.monthly')])">
      <h6 class="mt-3" style="padding: 0;">{{$t('map.monthly_rent_deposit')}}
        <small class="price">
          {{mc_range[0]}} ~ {{mc_range[1]}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="m_range" :enable-cross="false" :interval="10"
                    :min="0" :max="200" :tooltip="'none'" :marks="marks_m">
          <template v-slot:mark="{ pos, label }">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
      <h6 class="mt-5">{{$t('map.monthly_rent')}}
        <small class="price">
          {{dc_range[0]}} ~ {{dc_range[1]}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="d_range" :enable-cross="false" :interval="10"
                    :min="0" :max="200" :tooltip="'none'" :marks="marks_d">
          <template v-slot:mark="{ pos, label }">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
      <!--수수료-->
      <template v-if="false">
        <h6 class="mt-5">{{$t('register.monthly_fee')}}
          <small class="price">
            {{monthly[0]}} ~ {{(monthly[1] == 100) ? $t('map.unlimited') : monthly[1]}}
          </small>
        </h6>
        <div class="mt-3 mb-5 mr-3 ml-3">
          <vue-slider v-model="monthly" :enable-cross="false" :min="0" :interval="5"
                      :max="100" :tooltip="'none'" :marks="marks_fee">
            <template v-slot:mark="{pos, label}">
              <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
                |<br>{{ label }}
              </div>
            </template>
          </vue-slider>
        </div>
      </template>
    </div>
    <!-- Investment -->
    <div v-if="checkTransType($c.TRANS_TYPE_MAP1[$t('interest.invest')])">
      <h6 class="mt-3" style="padding: 0;">{{$t('interest.invest')}}
        <small class="price">
          {{ic_range[0]}} ~ {{ic_range[1]}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="i_range" :enable-cross="false" :interval="5"
                  :min="0" :max="100" :tooltip="'none'" :marks="marks1">
          <template v-slot:mark="{ pos, label }">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
      <template v-if="false">
        <!--수수료-->
        <h6 class="mt-5">{{$t('register.invest_fee')}}
          <small class="price">
            {{invest[0]}} ~ {{(invest[1] == 100) ? $t('map.unlimited') : invest[1]}}
          </small>
        </h6>
        <div class="mt-3 mb-5 mr-3 ml-3">
          <vue-slider v-model="invest" :enable-cross="false" :min="0" :interval="5"
                      :max="100" :tooltip="'none'" :marks="marks_fee">
            <template v-slot:mark="{pos, label}">
              <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
                |<br>{{ label }}
              </div>
            </template>
          </vue-slider>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Utils from '../../../config/utils.js'

export default {
  name: 'MFShape',
  data() {
    return {
      b_sale: false,
      b_charter: false,
      b_invest: false,
      b_month: false,
      marks_fee: {
        '0': {label: 0},
        '50': {label: 50},
        '100': {label: 100 +' '+ this.$t('map.more')},
      },
      marks: {
        '0':    {label: '0'},
        '500':  {label: Utils.currency_kilo_10000(50)},
        '1000': {label: Utils.currency_kilo_10000(100)},
      },
      marks1: {
        '0':   {label: '0'},
        '50':  {label: Utils.currency_baek_10000(50)},
        '100': {label: Utils.currency_kilo_10000(10)},
      },
      marks_m: {
        '0':   {label: '0'},
        '100': {label: Utils.currency_kilo_10000(10)},
        '200': {label: Utils.currency_kilo_10000(20)},
      },
      marks_d: {
        '0':   {label: '0'},
        '100': {label: Utils.currency_baek_10000(1)},
        '200': {label: Utils.currency_baek_10000(2)},
      },
    };
  },
  computed: {
    s_range: {
      get: function() {
        return [
          this.$store.getters.filter.sale_price_min,
          this.$store.getters.filter.sale_price_max
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          sale_price_min: v[0],
          sale_price_max: v[1]
        });
      },
    },
    c_range: {
      get: function() {
        return [
          this.$store.getters.filter.charter_price_min,
          this.$store.getters.filter.charter_price_max
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          charter_price_min: v[0],
          charter_price_max: v[1]
        });
      },
    },
    i_range: {
      get: function() {
        return [
          this.$store.getters.filter.invest_price_min,
          this.$store.getters.filter.invest_price_max
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          invest_price_min: v[0],
          invest_price_max: v[1]
        });
      },
    },
    m_range: {
      get: function() {
        return [
          this.$store.getters.filter.monthly_rent_deposit_min,
          this.$store.getters.filter.monthly_rent_deposit_max
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          monthly_rent_deposit_min: v[0],
          monthly_rent_deposit_max: v[1]
        });
      },
    },
    d_range: {
      get: function() {
        return [
          this.$store.getters.filter.monthly_rent_min,
          this.$store.getters.filter.monthly_rent_max
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          monthly_rent_min: v[0],
          monthly_rent_max: v[1]
        });
      },
    },
    trading: {
      get: function() {
        return [
          this.$store.getters.filter.fee_trading_min,
          this.$store.getters.filter.fee_trading_max,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          fee_trading_min: v[0],
          fee_trading_max: v[1],
        });
      },
    },
    charter: {
      get: function() {
        return [
          this.$store.getters.filter.fee_charter_min,
          this.$store.getters.filter.fee_charter_max,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          fee_charter_min: v[0],
          fee_charter_max: v[1],
        });
      },
    },
    invest: {
      get: function() {
        return [
          this.$store.getters.filter.fee_invest_min,
          this.$store.getters.filter.fee_invest_max,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          fee_invest_min: v[0],
          fee_invest_max: v[1],
        });
      },
    },
    monthly: {
      get: function() {
        return [
          this.$store.getters.filter.fee_monthly_min,
          this.$store.getters.filter.fee_monthly_max,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          fee_monthly_min: v[0],
          fee_monthly_max: v[1],
        });
      },
    },
    sc_range: function() {
      return [
        Utils.currency_baek_10000(this.s_range[0]),
        this.s_range[1] == 1000 ? this.$t('map.unlimited') : Utils.currency_baek_10000(this.s_range[1])
      ];
    },
    cc_range: function() {
      return [
        Utils.currency_baek_10000(this.c_range[0]),
        this.c_range[1] == 1000 ? this.$t('map.unlimited') : Utils.currency_baek_10000(this.c_range[1])
      ];
    },
    ic_range: function() {
      return [
        Utils.currency_baek_10000(this.i_range[0]),
        this.i_range[1] == 100 ? this.$t('map.unlimited') : Utils.currency_baek_10000(this.i_range[1])
      ];
    },
    mc_range: function() {
      return [
        Utils.currency_baek_10000(this.m_range[0]),
        this.m_range[1] == 200 ? this.$t('map.unlimited') : Utils.currency_baek_10000(this.m_range[1])
      ];
    },
    dc_range: function() {
      return [
        Utils.currency_10000(this.d_range[0]),
        this.d_range[1] == 200 ? this.$t('map.unlimited') : Utils.currency_10000(this.d_range[1])
      ];
    },
  },
  methods: {
    toggleNS() {
      if (this.$store.getters.filter.not_show_site_inquire == 'Y')
        this.$store.commit('setFilter', {not_show_site_inquire: 'N'});
      else
        this.$store.commit('setFilter', {not_show_site_inquire: 'Y'});
    },
    checkTransType: function(val) {
      var flts = (this.$store.getters.filter.trans_type == '' ? [] :
                  this.$store.getters.filter.trans_type.split(','));
      if (val == '')
        return (flts.length == 0);
      else
        return (flts.indexOf(val) != -1);
    },
    toggleTransType: function(val) {
      if (val == '')
        this.$store.commit('setFilter', {trans_type: ''});
      else {
        var flts = (this.$store.getters.filter.trans_type == '' ? [] :
                    this.$store.getters.filter.trans_type.split(','));
        var idx = flts.indexOf(val);
        if (idx != -1)
          flts.splice(idx, 1);
        else
          flts.push(val);
        this.$store.commit('setFilter', {trans_type: flts.join(',')});
      }
    },
    checkSalePrice: function() {
      return (this.$store.getters.filter.sale_price_min != 0 ||
              this.$store.getters.filter.sale_price_max != 1000);
    },
    checkCharterPrice: function() {
      return (this.$store.getters.filter.charter_price_min != 0 ||
              this.$store.getters.filter.charter_price_max != 1000);
    },
    checkInvestPrice: function() {
      return (this.$store.getters.filter.invest_price_min != 0 ||
              this.$store.getters.filter.invest_price_max != 100);
    },
    toggleSC: function() {
      if (this.$store.getters.filter.safe_charter == 'Y')
        this.$store.commit('setFilter', {safe_charter: ''});
      else
        this.$store.commit('setFilter', {safe_charter: 'Y'});
    },
    toggleSB: function() {
      if (this.$store.getters.filter.smb == 'Y')
        this.$store.commit('setFilter', {smb: ''});
      else
        this.$store.commit('setFilter', {smb: 'Y'});
    },
    checkDepositPrice: function() {
      return (this.$store.getters.filter.monthly_rent_deposit_min != 0 ||
              this.$store.getters.filter.monthly_rent_deposit_max != 200);
    },
    checkRentPrice: function() {
      return (this.$store.getters.filter.monthly_rent_min != 0 ||
              this.$store.getters.filter.monthly_rent_max != 200);
    },
  },
}
</script>

<style scoped lang="scss">
  @import '../../../assets/css/_vars.scss';
  h6 {
    font-size: $fs_18;
    font-family: $korean_gd_17_r;
    padding-top: 20px;
  }
  div.mfs-container {
    padding: 5px 40px 1px;
    background-color: white;
    width: 100%;
    margin: auto;
  }
  h6>small {
    color: #ccc9c9;
    font-size: $fs_18;
    font-family: $korean_gd_13_r;
  }
  button {
    margin-right: 8px;
    font-size: $fs_16;
    font-family: $korean_gd_14_r;
    border-width: 0.5px;
    border-radius: 5px;
    border-color: #eeeeef;
    height: 40px;
    padding: .375rem .75rem;
    margin-bottom: 5px;
  }
  h6>span {
    font-size: $fs_17;
    font-family: $korean_gd_14_r;
    color: $c_457fff;
  }
  h6>small.price {
    color: $primary;
    float: right;
    font-size: $fs_18;
    font-family: $korean_gd_14_r;
  }
  h6>small.notice {
    color: #cf0000;
    font-size: $fs_18;
    font-family: $korean_gd_15_r;
    float: right;
  }
  .img_check {
    width: 18px;
    height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/mf/MFShape.vue